import { render, staticRenderFns } from "./CompaniesAdmin.vue?vue&type=template&id=ae811892"
import script from "./CompaniesAdmin.vue?vue&type=script&lang=js"
export * from "./CompaniesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports